/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_MicrophoneInputs */



/**
* | output |
* | --- |
* | "Microphone" |
*
* @param {Practice_Session_Audio_MicrophoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_microphone = /** @type {((inputs?: Practice_Session_Audio_MicrophoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_MicrophoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microfoon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Micro")
	return /** @type {LocalizedString} */ ("Microphone")
});